import { createSlice } from '@reduxjs/toolkit';
import { PfLedgerState } from './pfLedgerType';
import {
  addAnnualInterest,
  fetchInterestSummaryByYear,
  fetchLedgerWithAccountDetails
} from './pfLedgerAction';

const initialState: PfLedgerState = {
  ledgerTransactions: [],
  pfEmployeeTransaction: null,
  interestSummary: [],
  loadingStates: {
    addInterest: false,
    fetchLedger: false,
    fetchInterestSummary: false
  },
  errors: {}
};

const pfLedgerSlice = createSlice({
  name: 'pfLedger',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add Annual Interest
      .addCase(addAnnualInterest.pending, (state) => {
        state.loadingStates.addInterest = true;
        state.errors.addInterest = undefined;
      })
      .addCase(addAnnualInterest.fulfilled, (state, action) => {
        state.loadingStates.addInterest = false;
        state.ledgerTransactions.unshift(action.payload.data);
      })
      .addCase(addAnnualInterest.rejected, (state, action) => {
        state.loadingStates.addInterest = false;
        state.errors.addInterest = action.payload as string;
      })
      .addCase(fetchInterestSummaryByYear.pending, (state) => {
        state.loadingStates.fetchInterestSummary = true;
        state.errors.fetchInterestSummary = undefined;
      })
      .addCase(fetchInterestSummaryByYear.fulfilled, (state, action) => {
        state.loadingStates.fetchInterestSummary = false;
        state.interestSummary = action.payload.data || action.payload; // depending on API structure
      })
      .addCase(fetchInterestSummaryByYear.rejected, (state, action) => {
        state.loadingStates.fetchInterestSummary = false;
        state.errors.fetchInterestSummary = action.payload as string;
      })

      // Fetch Ledger with Account Details
      .addCase(fetchLedgerWithAccountDetails.pending, (state) => {
        state.loadingStates.fetchLedger = true;
        state.errors.fetchLedger = undefined;
      })
      .addCase(fetchLedgerWithAccountDetails.fulfilled, (state, action) => {
        state.loadingStates.fetchLedger = false;
        state.pfEmployeeTransaction = action.payload.data;
      })
      .addCase(fetchLedgerWithAccountDetails.rejected, (state, action) => {
        state.loadingStates.fetchLedger = false;
        state.errors.fetchLedger = action.payload as string;
      });
  }
});

export default pfLedgerSlice.reducer;
